<template>
  <div class="has-text-centered scroll-top is-hidden-print">
    <a href="#" v-scroll-to="'#app'" class="has-text-grey-darker scroll-top__link">
      <b-icon icon="angle-double-up" size="is-medium"></b-icon>
      <p class="is-size-7 scroll-top__text is-uppercase">
        <span aria-hidden="true">Top</span> <span class="is-sr-only">{{ $t('general.go-to-top') }}</span>
      </p>
    </a>
  </div>
</template>

<script>
export default {
  name: 'ScrollToTop',
  props: {},
}
</script>

<style lang="scss">
.scroll-top {
  padding: 2rem 0 0 0;
}

.scroll-top__link {
  animation-name: hoverY;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-timing-function: cubic-bezier(0.445, 0.05, 0.55, 0.95);
  display: inline-block;
}

.scroll-top__text {
  display: block;
  margin-top: -0.2rem;
  text-align: center;
}

@keyframes hoverY {
  from {
    transform: translateY(0);
    opacity: 0.7;
  }
  to {
    transform: translateY(5px);
    opacity: 1;
  }
}
</style>
